import { render, staticRenderFns } from "./ListTabWebpartTest.vue?vue&type=template&id=de55deda"
import script from "./ListTabWebpartTest.vue?vue&type=script&lang=js"
export * from "./ListTabWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports